export enum ISTacticActionEnum {
  IMPROVE_SEO = 'IMPROVE_SEO',
  IMPROVE_PPC = 'IMPROVE_PPC',
  ADD_TO_NEGATIVES = 'ADD_TO_NEGATIVES',
  REMOVE_FROM_NEGATIVES = 'REMOVE_FROM_NEGATIVES',
}
